import EditCol from '../col/edit';

const EditRow = ({ line, columns, attributes, setAttributes }) => {
  const cols = [];
  for (let i = 0; i < columns; i++) {
    cols.push(
      <EditCol
        key={`col-${i}`}
        line={line}
        col={i}
        attributes={attributes}
        setAttributes={setAttributes}
      />
    );
  }

  return <tr>{cols}</tr>;
};

export default EditRow;
